import {useContext} from 'react';
import {PopperContext} from './PopperContext';

export const usePopperContext = () => {
  const context = useContext(PopperContext);

  if (!context) {
    throw new Error('PopperContext not found');
  }

  return context;
};
